import { useCallback, useEffect, useReducer, useState } from "react";
import { get, ref, set} from "firebase/database";
import { realTimeDB } from "./firebase";
import { CustomAlertDialog } from "./newComponents/CustomAlertDialog";
import { reducer,actionConsts } from "./newComponents/StateManager";
import { BackstageView } from "./newComponents/BackstageView";
import { format } from "date-fns";
import Historytab from "./newComponents/Historytab";
import { HbrCancel, HbrDropdownClickable} from "./newComponents/Mycustomsvgicons";

const CreateUserandToken = () => {

    const [livestreamToken,setLivestreamToken]=useState("");
    const [apikey,setApikey]=useState("");
    const [inputAccessKey,setInputAccessKey] = useState("");
    const [programType,setProgramType] = useState("");
    const [programHistory,setHistory]=useState([]);
    const [selectedHistory,setSelectHistory]=useState("Select from History");
    const [success,setsuccess]=useState(false);
    const [state,dispatch]=useReducer(reducer,{progressIndicator:false, alertMessage: "", showAlert: false,showHistory: false});
    const programHistoryDate = format(new Date(),"yyyyMMddHHmmss");


    const handlePrepareLiveToken=async(e)=>{
        e.preventDefault();
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
          const liveAccessKeysnapshot = await get(ref(realTimeDB,"Banner/accessliveId"));
          if(liveAccessKeysnapshot.exists()){
              if(liveAccessKeysnapshot.val() === inputAccessKey){
                const livestreamTokensnapshot = await get(ref(realTimeDB,"Banner/liveToken"));
                setLivestreamToken(livestreamTokensnapshot.val());
                const apikeySnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/apiKey"));
                setApikey(apikeySnapshot.val());
                set(ref(realTimeDB,"Banner/hbrLiveSettings/programType"),programType);
                set(ref(realTimeDB,"Banner/hbrLiveSettings/shareLink/shareInfo"),programType);
                set(ref(realTimeDB,`programtypehistory/${programHistoryDate}/title`),programType);
                setsuccess(true);
              
              }else{
                  dispatch({type: actionConsts.SHOWALERT, payload: true});
                  dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Invalid access live ID, make sure the access live ID is correctly entered"});
                  dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
                  setsuccess(false);
              }
          }
      };

      const handleCloseAlert=()=>{
        dispatch({type: actionConsts.SHOWALERT, payload: false});
      };

      useEffect(()=>{
        async function fetchHistory() {
          const programtypehistory = await get(ref(realTimeDB,"programtypehistory"));
          if (programtypehistory.exists()) {
            const subData = programtypehistory.val();
            const subDataArray = Object.keys(subData).map((key)=>({
              id: key,
              ...subData[key]
            }));
            setHistory(subDataArray);
          }
        }
        fetchHistory();
      },[]);

      const handleGetHistoryTextSelected=useCallback((textSelected)=>{
        if (textSelected) {
          setSelectHistory(textSelected);
          setProgramType(textSelected);
          dispatch({type:actionConsts.SHOWHISTORYTAB,payload:false});
        }
      },[]);

      const handleProgramTypeInputChange=(e)=>{
          setProgramType(e.target.value);
          dispatch({type:actionConsts.SHOWHISTORYTAB,payload:true});
      };

   


    return !success ? (
        <div className="createlivetoken flex-column2" style={{
                width:"100%",
                height:"100vh",
                overflow:"auto"
                }}>

              {state.showAlert && 
                  <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert}/>
              }

                <div className="programhistory flex-column2" style={{position:"fixed",top:"2em",left:"0px",right:"0px",width:"100%"}}>
                    <div style={{width:"100%",display:"grid",placeItems:"center"}}>

                      <div className="flex-row2" style={{position:"relative",width:"40%",backgroundColor:"white"}}>
                        <input type="text" 
                        value={selectedHistory} readOnly onChange={(e)=>setSelectHistory(e.target.value)}
                        style={{width:"90%",border:"none",outline:"none",padding:"8px",color:"#000000",caretColor:"transparent"}}
                        />
                        {!state.showHistory && 
                        <div>
                        <HbrDropdownClickable width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>dispatch({type:actionConsts.SHOWHISTORYTAB,payload:true})}/>
                        </div>
                    
                        }
                       
                        {state.showHistory && 
                          <div style={{position:"absolute",right:"0px"}}>
                          <HbrCancel width={"1.7em"} height={"1.7em"} fillColour={"black"} handleClick={()=> dispatch({type:actionConsts.SHOWHISTORYTAB,payload:false})}/>
                        </div>
                        }

                      {state.showHistory && 
                        <div className="historytablayout">

                            {programHistory && programHistory.filter((previousprogram)=>{
                            if(programType === ""){
                                //  dispatch({type:actionConsts.SHOWHISTORYTAB,payload:false})
                              return true;
                            }else if(previousprogram.title.replace(/[^\w\s]|_/g, '').toLowerCase().includes(programType.toLowerCase())){
                                return true;
                            }
                              return false;
              
                            }).map(data => (
                            <Historytab
                            key={data.id}
                            id={data.id}
                            title={data.title}
                            historyTextSelected={handleGetHistoryTextSelected}
                            />
                          ))}
                        </div>
                      }
                      </div>
               
                    </div>
          
                </div>

        
              <form onSubmit={handlePrepareLiveToken} className="livetokenform">
                <h3>Creator Access Key Required</h3>
                <input type="text" placeholder="Enter the program name" value={programType} onChange={handleProgramTypeInputChange}/>
                
                <input type="text" placeholder="Enter access Key" value={inputAccessKey} onChange={e => setInputAccessKey(e.target.value.trim())}/>
                <button style={{
                      backgroundColor:"#0E78F9",
                      color:"white",
                      fontWeight:"bold",
                      borderRadius:"10px",
                      cursor:"pointer",
                      padding:"10px",
                      border:"none"}}>
                        Proceed
                </button>

                {state.progressIndicator && 
                          <div style={{
                              position:"absolute",
                              top:"50%",
                              left:"45%",
                              width:"50px",
                              height:"50px",
                              border: "5px solid black",
                              borderTop: "5px solid #0E78F9",
                              borderRadius: "50%",
                              animation: "spin2 2s linear infinite",
                              backgroundColor: "#FFFFFF"
                              }}>
                          </div>
                      }
            </form>
            

        </div>
      ):(
        <BackstageView token={livestreamToken} apiKey={apikey} liveDesc={programType}/>
      )
}
export default CreateUserandToken;